/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { useQuery, useQueryClient } from '@tanstack/react-query';
import { flightKeys } from './flights';

export interface MultiCartContextState {
  cartId?: string;
  sourceLob?: string;
  channelHash?: string;
  sourceDeeplink?: string;
  uiHide?: string;
  uiDisable?: string;
  airasiaFlightOnly?: boolean | string;
}

export const useMultiCartContext = () => {
  const queryClient = useQueryClient();

  const { data } = useQuery<MultiCartContextState>({
    queryKey: flightKeys.multiCartContext,
    initialData: {},
    queryFn: () => ({}),
    staleTime: Infinity,
    gcTime: Infinity,
  });

  const updateMultiCartContext = (updates: Partial<MultiCartContextState>) => {
    queryClient.setQueryData<MultiCartContextState>(
      flightKeys.multiCartContext,
      (prev) => ({
        ...prev,
        ...updates,
      }),
    );
  };

  const clearMultiCartContext = () => {
    queryClient.setQueryData<MultiCartContextState>(
      flightKeys.multiCartContext,
      {},
    );
  };

  return {
    multiCart: data ?? {},
    updateMultiCartContext,
    clearMultiCartContext,
  };
};
